/* Salvona — cart: quantity, remove and note without page reloads */
(function(){
  function init(root){
    if(root.dataset.init) return; root.dataset.init='1';
    var sid=root.dataset.section, busy=false;
    function refresh(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=doc.querySelector('[data-svk]'); if(!fresh) return location.reload();
      root.replaceWith(fresh); init(fresh);
    }
    function change(key,qty){
      if(busy) return; busy=true; root.classList.add('is-busy');
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(function(r){return r.json();})
        .then(function(c){
          /* let the theme header update its cart bubble */
          document.querySelectorAll('cart-icon').forEach(function(el){if(typeof el.renderCartBubble==='function')el.renderCartBubble(c.item_count,false);});
          return fetch(location.pathname+'?section_id='+encodeURIComponent(sid));
        })
        .then(function(r){return r.text();}).then(refresh)
        .catch(function(){location.reload();});
    }
    root.querySelectorAll('.svk-item').forEach(function(li){
      var key=li.dataset.key, inp=li.querySelector('[data-svk-qty]');
      li.querySelectorAll('[data-svk-step]').forEach(function(b){
        b.addEventListener('click',function(){var v=Math.max(0,(parseInt(inp.value,10)||0)+parseInt(b.dataset.svkStep,10));inp.value=v;change(key,v);});
      });
      inp.addEventListener('change',function(){change(key,Math.max(0,parseInt(inp.value,10)||0));});
      var rm=li.querySelector('[data-svk-remove]');
      rm.addEventListener('click',function(e){e.preventDefault();li.classList.add('is-leaving');change(key,0);});
    });
    root.querySelectorAll('[data-svk-attr]').forEach(function(el){
      el.addEventListener('change',function(){
        var a={};root.querySelectorAll('[data-svk-attr]').forEach(function(x){if(x.type==='radio'&&!x.checked)return;a[x.name.replace(/^attributes\[|\]$/g,'')]=x.value;});
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:a})});
      });
    });
    var note=root.querySelector('[data-svk-note]'),t;
    if(note) note.addEventListener('input',function(){clearTimeout(t);t=setTimeout(function(){fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note.value})});},500);});
  }
  function boot(){document.querySelectorAll('[data-svk]').forEach(init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
